<div class="card-content">
  <div class="upper-card">
    <button [attr.aria-expanded]="!isCollapsed" aria-controls="collapseBasic" (click)="mais()" class="chevron">
      <i-bs *ngIf="isCollapsed" name="chevron-down"></i-bs>
      <i-bs *ngIf="!isCollapsed" name="chevron-up"></i-bs>
    </button>
    <p>Nome do aluno diplomado:</p>
    <label class="info">{{maisInfo.nomAluno}}</label>
    <p>CPF</p>
    <label class="info">{{maisInfo.cpfAluno}}</label>

    <!--<div class="container-botoes-card d-block d-md-none" *ngIf="!isCollapsed">
      <button class="btn-card-resultado">Baixar xml</button>
      <button class="btn-card-resultado">Visualizar</button>
    </div>-->
  </div>

  <div id="collapseBasic" [collapse]="isCollapsed" [isAnimated]="true">
    <div class="mais-info-body">
      <p>Curso de graduação:</p>
      <label>{{maisInfo.nomeCursoEMEC}}</label>
      <p>IES Expedidora:</p>
      <label>{{maisInfo.nomeInstituicaoExpedidoraEMEC}}</label>
      <p>IES Registradora:</p>
      <label>{{maisInfo.nomeInstituicaoRegistraEMEC}}</label>
      <p>Data de Ingresso no curso:</p>
      <label>{{maisInfo.dataIngressoCurso}}</label>
      <p>Data de conclusão do curso:</p>
      <label>{{maisInfo.dataConclusaoCurso}}</label>
      <p>Data de expedição do histórico:</p>
      <label>{{maisInfo.dataExpedicaoDiploma}}</label>
      <p>Data de registro do histórico:</p>
      <label>{{maisInfo.dataRegistroDiploma}}</label>
      <p>Numero de expedição do histórico:</p>
      <label>{{maisInfo.numRegistroExpedicaoDiploma}}</label>
      <p>Data de publicação no Diário Oficial da União - D.O.U:</p>
      <label>{{maisInfo.dataRegistroDOU}}</label>
    </div>
  </div>
</div>



